import { Box, Tooltip } from '@mui/material'
import React from 'react'
import { clampPercent } from '../profileLogic'

const DOT_SIZE = 8
const RING = 4

interface PeerMeanMarkerProps {
  percent: number
  label?: string
}

const PeerMeanMarker: React.FC<PeerMeanMarkerProps> = ({ percent, label }) => (
  <Tooltip title={label} placement="top" arrow>
    <Box
      role="img"
      aria-label={label}
      position="absolute"
      top="50%"
      left={`${clampPercent(percent)}%`}
      width={DOT_SIZE + RING * 2}
      height={DOT_SIZE + RING * 2}
      borderRadius="50%"
      bgcolor="text.primary"
      sx={{ transform: 'translate(-50%, -50%)', border: RING, borderColor: 'background.paper' }}
    />
  </Tooltip>
)

export default PeerMeanMarker
